export const blockIconsSocialWorkspacePremium = (
	<span className='material-symbols-outlined'>workspace_premium</span>
);
